import { FC } from 'react';
import { Grid } from '@mui/material';
import StudentDocumentsGrid from './studentDocumentsGrid.view';
import { useStudentFiltersState } from '../../contexts/studentFilters.context';
import { useStudentsState } from '../../contexts/students.context';
import StudentManageDocumentView from './studentManageDocument.view';
import { useStudentDocumentsState } from '../../contexts/studentDocuments.context';
import { PermissionGate } from '../../../../../components/rbac/PermissionGate';
import { RbacDeniedRedirect } from '../../../../../components/rbac/RbacDeniedRedirect';

const StudentDocumentsView: FC = () => {
  const filters = useStudentFiltersState();
  const { isLoading } = useStudentsState();
  const {
    studentDocumentsAppState: { isManageDocumentOpen },
  } = useStudentDocumentsState();

  return (
    <PermissionGate
      module="students"
      submodule="documents"
      permission="read"
      fallback={<RbacDeniedRedirect />}
    >
      <Grid
        container
        spacing={{ xs: 1, sm: 2 }}
        sx={{
          height: '100%',
          p: { xs: 1, sm: 2 },
        }}
        data-testid="student-documents-view-container"
      >
        <StudentDocumentsGrid
          key={`${filters.grade}-${filters.section}`}
          isLoading={isLoading}
        />
        {isManageDocumentOpen && <StudentManageDocumentView />}
      </Grid>
    </PermissionGate>
  );
};

export default StudentDocumentsView;
